import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IClientInvoice} from "../../../models/IClientInvoice";
import {
    fetchGetAllClientInvoices,
    fetchGetMyClientInvoices,
    fetchIssueClientInvoice,
    fetchUpdateClientInvoiceStatus,
} from "./actions";

interface IClientInvoiceState {
    list: IClientInvoice[];
    /** Чьи счета лежат в list: свои (Профиль → Баланс) или все (админ). Общий list — при смене очищаем. */
    listScope: "my" | "all" | null;
    isLoading: boolean;
    current: IClientInvoice | null;
    isIssuing: boolean;
}

const initialState: IClientInvoiceState = {
    list: [],
    listScope: null,
    isLoading: false,
    current: null,
    isIssuing: false,
};

export const ClientInvoiceSlice = createSlice({
    name: "client_invoice",
    initialState,
    reducers: {
        setCurrentInvoice: (
            state,
            action: PayloadAction<IClientInvoice | null>,
        ) => {
            state.current = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            // ── Issue ───────────────────────────────────────────────────
            .addCase(
                fetchIssueClientInvoice.fulfilled,
                (state, action: PayloadAction<IClientInvoice>) => {
                    state.current = action.payload;
                    state.isIssuing = false;
                },
            )
            .addCase(fetchIssueClientInvoice.pending, (state) => {
                state.isIssuing = true;
            })
            .addCase(fetchIssueClientInvoice.rejected, (state) => {
                state.isIssuing = false;
            })

            // ── Get My ──────────────────────────────────────────────────
            .addCase(
                fetchGetMyClientInvoices.fulfilled,
                (state, action: PayloadAction<IClientInvoice[]>) => {
                    state.list = action.payload;
                    state.listScope = "my";
                    state.isLoading = false;
                },
            )
            .addCase(fetchGetMyClientInvoices.pending, (state) => {
                if (state.listScope !== "my") state.list = [];
                state.listScope = "my";
                state.isLoading = true;
            })
            .addCase(fetchGetMyClientInvoices.rejected, (state) => {
                state.isLoading = false;
            })

            // ── Get All (admin) ─────────────────────────────────────────
            .addCase(
                fetchGetAllClientInvoices.fulfilled,
                (state, action: PayloadAction<IClientInvoice[]>) => {
                    state.list = action.payload;
                    state.listScope = "all";
                    state.isLoading = false;
                },
            )
            .addCase(fetchGetAllClientInvoices.pending, (state) => {
                if (state.listScope !== "all") state.list = [];
                state.listScope = "all";
                state.isLoading = true;
            })
            .addCase(fetchGetAllClientInvoices.rejected, (state) => {
                state.isLoading = false;
            })

            // ── Update Status ───────────────────────────────────────────
            .addCase(
                fetchUpdateClientInvoiceStatus.fulfilled,
                (state, action: PayloadAction<IClientInvoice>) => {
                    state.list = state.list.map((inv) =>
                        inv.id === action.payload.id ? action.payload : inv,
                    );
                    state.isLoading = false;
                },
            )
            .addCase(fetchUpdateClientInvoiceStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchUpdateClientInvoiceStatus.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export const {setCurrentInvoice} = ClientInvoiceSlice.actions;

export default ClientInvoiceSlice.reducer;